<div style="page-break-inside: avoid;" *ngIf="undisclosedIncome?.length" class="mt-4" [ngClass]="{'container': !isSinglePageReturn, 'return-view-background-print': !isSinglePageReturn && printActive, 'return-view-background': !isSinglePageReturn && !printActive}">
    <div class="row mb-4">
        <div class="col-12 text-center">
            <strong>Declaration for Voluntary Disclosure of Income</strong><br/>
            <i>[Under 1st Schedule of ITA, 2023]</i>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6"><strong>Taxpayer Name:</strong> {{returnData?.profileData?.assesName}}</div>
        <div class="col-sm-6 text-right">
           <strong>Assessment Year:</strong> {{returnData?.submissionInfo?.assessmentYear}}
        </div>
    </div>
    <div class="row mt-3 mb-5">
        <div class="col-sm-12">
            <strong>TIN</strong>&ensp;&ensp;
            <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item}}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default" disabled/>
            </span>
        </div>
    </div>

    <div *ngIf="undisclosedIncome?.length" style="page-break-inside: avoid" class="row mb-4">
        <div class="col-12 text-center mb-3 font-weight-bold">
            Undisclosed Income
        </div>
        <div class="col-12">
            <table class="table table-bordered">                
                <tbody>
                    <tr>
                        <td class="text-center" colspan="2">Heads of Income</td> 
                        <td class="text-center">Particulars</td>
                        <td class="text-center">Assessment Year of Earning</td>
                        <td class="text-center">Amount</td>                  
                    </tr> 
                    <tr *ngFor="let item of undisclosedIncome; let i = index">
                        <td class="text-center">{{i+1}}</td> 
                        <td class="text-start">{{item?.incomeHead}}</td> 
                        <td class="text-start pr-3">{{item?.particulars}}</td> 
                        <td class="text-start pr-3">{{item?.incomeAy}}</td>
                        <td class="text-right pr-3">{{item?.netIncome | currencySeparatorBD}}</td>            
                    </tr>                                
                </tbody>
            </table>
        </div>
    </div>

    <div style="page-break-inside: avoid" class="row mb-5 ml-2">
        <div class="col-6">
            <div class="row">
                <div class="col-3">
                    <b>Tax Paid:</b>
                </div>
                <div class="col-9">
                    <span class="text-right">{{taxPaid | currencySeparatorBD}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-3">
                    <b>Penalty Paid:</b>
                </div>
                <div class="col-9">
                    <span class="text-right">{{penaltyPaid | currencySeparatorBD}}</span>
                </div>
            </div>
        </div>
    </div>

    <div style="margin-top:80px; page-break-inside: avoid" class="text-center">
        <u class="font-weight-bold">
          Verification
        </u>
    </div>
    <div class="row mb-5 mt-3">
        <input type="checkbox" class="verification-checkbox" id="verificationOfIncome" checked disabled>
        <div class="col-sm-12 ml-2">
            {{verificationMessage}}
        </div>
    </div>
    <div class="row " style="margin-top:70px;">
        <div class="col-sm-6"></div>
        <div class="col-sm-6 text-center">
            <div>{{returnData?.profileData?.assesName}}</div>
            <div>
            Name & Signature of the Taxpayer
            </div>
            <div>
            Date: {{dateAfterSign}}
            </div>
            <div><strong><i>System generated document, it requires no signature</i></strong></div>
            <!-- <div class="pt-1 font-italic font-weight-bold">সিস্টেম জেনারেটেড ডকুমেন্ট। স্বাক্ষরের প্রয়োজন নেই।</div> -->
        </div>
    </div>
</div>
